import { OnInit, Directive, inject } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Directive()
export abstract class BeachyGenericErrorComponent implements OnInit {
  protected activatedRoute = inject(ActivatedRoute);
  protected location = inject(Location);

  error: string | null = null;

  ngOnInit() {
    const { url, errorMessage } = this.activatedRoute.snapshot.queryParams;

    if (url) {
      this.location.replaceState(url);
    }

    if (errorMessage) {
      this.error = errorMessage;
    }
  }

  startOver() {
    this.cleanup();
    this.navigateToGetStartedPage();
  }

  abstract cleanup(): void;
  abstract navigateToGetStartedPage(): void;
}
